<div class="terms-and-conditions-dialog">
  <div class="terms-and-conditions-dialog__header">
    <bdeo-button type="basic" icon="action-close" bigIcon="true" (click)="close()"></bdeo-button>
  </div>
  <div class="terms-and-conditions-dialog__content" [innerHTML]="data.htmlContent"></div>
</div>
